<template>
  <footer class="app-footer">
    <ul class="list-inline">
      <li class="list-inline-item">
        <a class="text-muted" href="#">Support</a>
      </li>
      <li class="list-inline-item">
        <a class="text-muted" href="#">Help Center</a>
      </li>
      <li class="list-inline-item">
        <a class="text-muted" href="#">Privacy</a>
      </li>
      <li class="list-inline-item">
        <a class="text-muted" href="#">Terms of Service</a>
      </li>
    </ul>
    <div class="copyright"> Copyright © 2018. All right reserved. </div>
  </footer>
</template>

<script>
    export default {
      name: "Footer",
      data (){
       return {
          client_height:0
       }
      },
      watch:{
        '$route'(){
          this.client_height = this.$parent.$refs.app.clientHeight
        }
      },
      methods: {
        isFixed(){

          this.client_height = this.$parent.$refs.app.clientHeight

          let result
          if (screen.width <= 768){
            if (this.client_height >= 550){
              result  = true
            }else{
              result = false
            }
          }else{
            result = this.client_height >= 800
          }

          return result
        }
      },
      beforeDestroy() {
        if (typeof window !== 'undefined') {
          window.removeEventListener('resize', this.isFixed, {passive: true})
        }
      },
      mounted() {
        this.isFixed()
        window.addEventListener('resize', this.isFixed, {passive: true})
      }
    }
</script>

<style scoped>
.relative{
  z-index:1029;
  clear: both;
  position: relative;
  bottom:0px;
  width:100%;
  height:auto;
}

.fixed {

  z-index:1029;
  clear: both;
  position: fixed;
  bottom:0px;
  width:100%;
  height: auto;
}
.row-margin-top {
  margin-top: 18px;
  position:inherit;
}
.margin-left {
  margin-left: 2%;
}
</style>